import { Step } from "./Step";
import { StepTypes } from "../../enum/StepTypes";
import { MultiLanguage } from "../../MultiLanguage";

export class AuthorizarionStep extends Step {
    private _authorizationEntities: any[];
    private _entityName: string;
    private _authorizationText: MultiLanguage;
    private _refuseText: MultiLanguage;

    constructor(step: any,processConfigurationAuthorizations: any[]) {
        super(step);
        this._name = StepTypes.translations[step.type].name;
        this._authorizationEntities = processConfigurationAuthorizations.filter(auth => step.authorizationEntities.includes(auth.authorizationType) );
        this._entityName = step.entityName;
        this._authorizationText = new MultiLanguage(step.authorizationText);
        this._refuseText = new MultiLanguage(step.refuseText);
    }

    public get authorizationEntities(): number[] {
        return this._authorizationEntities;
    }
    public get entityName(): string {
        return this._entityName;
    }
    public get authorizationText(): MultiLanguage {
        return this._authorizationText;
    }
    public get refuseText(): MultiLanguage {
        return this._refuseText;
    }
}